import { AddressInfoType } from "@/enums/enums";
import { AddressDetailModel, MerchantAddressModel } from "@/model/address/addressModel";
import { MerchantDetail } from "@/model/merchant/merchantModel";
import { IsHaveThaiText, IsStartWithNumber } from "./textHelper";

export function GetAddress(addressDetail: AddressDetailModel, addressInfoType?: AddressInfoType) {
  let address;
  if (addressInfoType == AddressInfoType.RegisteredAddressEn || !IsHaveThaiText(addressDetail.province)) {
    address =
      (addressDetail.address ? addressDetail.address + " " : "") +
      (addressDetail.building ? addressDetail.building + " " : "") +
      (addressDetail.floorNo ? addressDetail.floorNo + " " : "") +
      (addressDetail.roomNo ? addressDetail.roomNo + " " : "") +
      (addressDetail.homeGroup ? addressDetail.homeGroup + " " : "") +
      (addressDetail.homeNo ? addressDetail.homeNo + " " : "") +
      (addressDetail.soi ? addressDetail.soi + " " : "") +
      (addressDetail.road ? addressDetail.road : "");
  } else {
    address =
      (addressDetail.address
        ? (IsStartWithNumber(addressDetail.address) ? "เลขที่ " + addressDetail.address : addressDetail.address) + " "
        : "") +
      (addressDetail.building ? "อาคาร " + addressDetail.building + " " : "") +
      (addressDetail.floorNo ? "ชั้น " + addressDetail.floorNo + " " : "") +
      (addressDetail.roomNo ? "ห้องเลขที่ " + addressDetail.roomNo + " " : "") +
      (addressDetail.homeGroup ? "หมู่บ้าน " + addressDetail.homeGroup + " " : "") +
      (addressDetail.homeNo ? "หมู่ที่ " + addressDetail.homeNo + " " : "") +
      (addressDetail.soi ? "ซอย " + addressDetail.soi + " " : "") +
      (addressDetail.road ? "ถนน " + addressDetail.road : "");
  }
  if (
    addressInfoType == AddressInfoType.RegisteredAddressEn ||
    (!IsHaveThaiText(addressDetail.country) &&
      !IsHaveThaiText(address + addressDetail.province + addressDetail.district + addressDetail.subDistrict))
  ) {
    return `${address ? address : ""} ${addressDetail.subDistrict ? addressDetail.subDistrict : ""} ${
      addressDetail.district ? addressDetail.district : ""
    } ${addressDetail.province ? addressDetail.province : ""} ${
      addressDetail.country && address ? addressDetail.country : ""
    } ${addressDetail.postCode ? addressDetail.postCode : ""}`;
  } else {
    const districtPrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? "เขต"
        : "อำเภอ"
      : "";
    const subDistrictPrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? "แขวง"
        : "ตำบล"
      : "";
    const provincePrefix = addressDetail.province
      ? addressDetail.province.startsWith("กรุงเทพ")
        ? ""
        : "จังหวัด"
      : "";

    return `${address} ${subDistrictPrefix}${addressDetail.subDistrict} ${districtPrefix}${addressDetail.district} ${provincePrefix}${addressDetail.province} ${addressDetail.postCode}`;
  }
}

export function ConvertToAddressDetail(merchantDetail: MerchantDetail | AddressDetailModel) {
  const addressDetail: AddressDetailModel = {
    address: merchantDetail.address,
    building: merchantDetail.building,
    country: merchantDetail.country,
    district: merchantDetail.district,
    floorNo: merchantDetail.floorNo,
    homeGroup: merchantDetail.homeGroup,
    homeNo: merchantDetail.homeNo,
    postCode: merchantDetail.postCode,
    province: merchantDetail.province,
    road: merchantDetail.road,
    roomNo: merchantDetail.roomNo,
    soi: merchantDetail.soi,
    subDistrict: merchantDetail.subDistrict,
  };
  return addressDetail;
}

export function GetMerchantAddressModelDefault() {
  const addressDetail: MerchantAddressModel = {
    addressInfoType: 0,
    address: "",
    building: "",
    country: "",
    district: "",
    floorNo: "",
    homeGroup: "",
    homeNo: "",
    postCode: "",
    province: "",
    road: "",
    roomNo: "",
    soi: "",
    subDistrict: "",
    addressName: "",
    id: 0,
    language: "",
    name: "",
  };
  return addressDetail;
}
